"use client"

import { AlignVerticalSpaceBetween } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `AlignVerticalSpaceBetweenIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const AlignVerticalSpaceBetweenIcon = component(Icon)({
  as: AlignVerticalSpaceBetween,
})
